import { A } from '@mobily/ts-belt';
import { Box, FormHelperText, List, ListItem, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { AllocationRecord } from '@sh4res/bo-common/components/B2bCampaigns/steps/allocations/AllocationsConfirmationStep';

type Props = {
  blockedCampaignEmployees: Pick<AllocationRecord, 'firstname' | 'lastname' | 'identifier'>[];
};

export const BlockedCampaignEmployeesSection = ({ blockedCampaignEmployees }: Props) => {
  const translate = useTranslate();

  if (A.isEmpty(blockedCampaignEmployees)) {
    return null;
  }

  return (
    <Box mt={1} sx={{ overflowY: 'auto', maxHeight: '200px' }}>
      <FormHelperText sx={{ fontSize: 14, color: 'warning.main' }}>
        <Typography component="p" variant="inherit" color="inherit">
          {translate(
            'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.part1',
          )}
        </Typography>
        <Typography component="p" variant="inherit" color="inherit" sx={{ mt: 1 }}>
          {translate(
            'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.part2',
          )}
        </Typography>
        <List dense disablePadding sx={{ mt: 0.5 }}>
          {blockedCampaignEmployees.map((employee, index) => (
            <ListItem key={index} sx={{ display: 'list-item', pl: 2, py: 0 }}>
              {employee.identifier} - {employee.firstname} {employee.lastname}
            </ListItem>
          ))}
        </List>
        <Typography component="p" variant="inherit" color="inherit" sx={{ mt: 0.75 }}>
          {translate(
            'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.part3',
          )}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {translate(
              'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.part3bold',
            )}
          </Box>
        </Typography>
        <List
          dense
          disablePadding
          component="ul"
          sx={{
            mt: 0.5,
            pl: 2.5,
            listStyleType: 'disc',
            '& .MuiListItem-root': { display: 'list-item', py: 0 },
          }}>
          <ListItem>
            {translate(
              'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.bullet1',
            )}
          </ListItem>
          <ListItem>
            {translate(
              'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.bullet2',
            )}
          </ListItem>
        </List>
        <Typography component="p" variant="inherit" color="inherit" sx={{ mt: 0.75 }}>
          {translate(
            'resources.bo_common.b2b.campaigns.sections.review.warnings.campaigns_blocked_employees.part4',
          )}
        </Typography>
      </FormHelperText>
    </Box>
  );
};
